import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import PokerChipStacks, { PokerChipStacksProps } from './PokerChipStacks';

interface AnimatedPokerChipStacksProps extends PokerChipStacksProps {
  fromPosition: { x: number; y: number };
  toPosition: { x: number; y: number };
  onAnimationComplete?: () => void;
  shouldAnimate?: boolean;
  useTrigger?: boolean;
  skipAnimation?: boolean;
}

const AnimatedPokerChipStacks: React.FC<AnimatedPokerChipStacksProps> = ({
  fromPosition,
  toPosition,
  onAnimationComplete,
  shouldAnimate,
  amount,
  useTrigger,
  skipAnimation,
  ...rest
}) => {
  const [savedAmount, setSavedAmount] = useState(amount);
  const [triggerAnimation, setTriggerAnimation] = useState(false);
  const handleOnAnimationComplete = () => {
    if (onAnimationComplete) onAnimationComplete();
    setSavedAmount(amount);
    setTriggerAnimation(false);
  };
  useEffect(() => {
    if (skipAnimation) setSavedAmount(amount);
    else if (amount !== 0) setSavedAmount(amount);
  }, [amount]);

  useEffect(() => {
    if (shouldAnimate) {
      setTriggerAnimation(true);
    }
  }, [shouldAnimate]);

  return (
    <motion.div
      className="z-[100]"
      initial={{ x: fromPosition?.x, y: fromPosition?.y, opacity: 1 }}
      animate={
        skipAnimation
          ? undefined
          : (useTrigger ? triggerAnimation : shouldAnimate)
            ? {
                x: toPosition?.x,
                y: toPosition?.y,
                opacity: [1, 1, 0],
                transition: { duration: 1, times: [0, 0.9, 1] },
              }
            : undefined
      }
      transition={{
        duration: skipAnimation ? 0 : (useTrigger ? triggerAnimation : shouldAnimate) ? 1 : 0,
      }}
      onAnimationComplete={handleOnAnimationComplete}
    >
      <PokerChipStacks {...rest} amount={savedAmount} />
    </motion.div>
  );
};

export default AnimatedPokerChipStacks;
